import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import "./App.css";

import Splash from "./pages/auth/Splash";
import Welcome from "./pages/auth/Welcome";

import ProtectedRoute from "./components/ProtectedRoute";
import BusinessProtectedRoute from "./business/components/BusinessProtectedRoute";


import ModeManager from "./components/ModeManager";
import { CartProvider } from "./context/CartContext";
// ==========================
// Authentication
// ==========================

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import CustomerRegister from "./pages/auth/CustomerRegister";
import ProviderRegister from "./pages/auth/ProviderRegister";
import DeliveryRegister from "./pages/auth/DeliveryRegister";
import ForgotPassword from "./pages/auth/ForgotPassword";
import RegistrationSuccess from "./pages/provider/RegistrationSuccess";
import DeliveryCompleteProfile from "./pages/delivery/DeliveryCompleteProfile/DeliveryCompleteProfile";
import DeliveryVehicleBank from "./pages/delivery/DeliveryVehicleBank/DeliveryVehicleBank";
import DeliveryApplicationSubmitted from "./pages/delivery/DeliveryApplicationSubmitted/DeliveryApplicationSubmitted";
import DeliveryProfile from "./pages/delivery/DeliveryProfile/DeliveryProfile";
import DeliveryHome from "./pages/delivery/DeliveryHome/DeliveryHome";
import DeliveryOrders from "./pages/delivery/Orders/Orders";
import DeliveryEarnings from "./pages/delivery/Earnings/Earnings";
import DeliveryNotifications from "./pages/delivery/Notifications/DeliveryNotifications";
import DeliverySettings from "./pages/delivery/Settings/DeliverySettings";
import EditProfile from "./pages/delivery/EditProfile/EditProfile";
import ChangePassword from "./pages/delivery/ChangePassword/ChangePassword";
import DeliveryNotificationSettings from "./pages/delivery/NotificationSettings/NotificationSettings";
import OTPVerification from "./pages/delivery/OTPVerification/OTPVerification";
import DeliveryLocation from "./pages/delivery/DeliveryLocation/DeliveryLocation";
import DeliveryPrivacy from "./pages/delivery/DeliveryPrivacy/DeliveryPrivacy";
import DeliveryTerms from "./pages/delivery/DeliveryTerms/DeliveryTerms";
import DeliverySupport from "./pages/delivery/DeliverySupport/DeliverySupport";
import DeliveryAbout from "./pages/delivery/DeliveryAbout/DeliveryAbout";
// ==========================
// Customer Pages
// ==========================

import CustomerHome from "./pages/customer/CustomerHome";
import ProviderDetails from "./pages/customer/ProviderDetails";
import FoodDetails from "./pages/customer/FoodDetails";
import Checkout from "./pages/customer/Checkout";
import Favorites from "./pages/customer/Favorites/Favorites";
import Profile from "./pages/customer/Profile";

import CustomerSettings from "./pages/customer/Settings/Settings";
import PersonalInformation from "./pages/customer/Settings/pages/PersonalInformation";
import NotificationSettings from "./pages/customer/Settings/pages/NotificationSettings";
import CustomerPrivacySettings from "./pages/customer/Settings/pages/PrivacySettings";
import CustomerSecuritySettings from "./pages/customer/Settings/pages/CustomerSecuritySettings";
import CustomerAppearanceSettings from "./pages/customer/Settings/pages/CustomerAppearanceSettings";
import CustomerLanguageSettings from "./pages/customer/Settings/pages/CustomerLanguageSettings";
import CustomerPaymentMethods from "./pages/customer/Settings/pages/CustomerPaymentMethods";
import CustomerSavedAddresses from "./pages/customer/Settings/pages/CustomerSavedAddresses";
import CustomerHelpSupport from "./pages/customer/Settings/pages/CustomerHelpSupport";
import CustomerAbout from "./pages/customer/Settings/pages/CustomerAbout";
import CustomerDangerZone from "./pages/customer/Settings/pages/CustomerDangerZone";
import CustomerOrdersPage from "./pages/customer/MyOrders/pages/MyOrders";
import Messages from "./pages/customer/Messages/Messages";

import RecommendedProviders from "./pages/customer/RecommendedProviders/RecommendedProviders";
import BecomeProvider from "./pages/BecomeProvider";
import OrderSuccess from "./pages/customer/OrderSuccess/OrderSuccess";
import CustomerNotifications from "./pages/customer/Notifications";
import LiveTracking from "./pages/customer/LiveTracking/LiveTracking";

// ==========================
// Business Pages
// ==========================

import BusinessHome from "./business/pages/BusinessHome";
import BusinessProfile from "./business/pages/BusinessProfile";
import Orders from "./business/pages/Orders";
import NotificationPermission from "./pages/onboarding/NotificationPermission";
import ProviderMessages from "./business/pages/Messages/ProviderMessages";
import CustomOrderReview from "./business/pages/CustomOrders/CustomOrderReview";
import LocationPermission from "./pages/onboarding/LocationPermission";
import ChooseService from "./pages/onboarding/ChooseService";
import FoodManagementPage from "./business/components/Managements/FoodManagement/pages/FoodManagementPage";
import BakeryManagementPage from "./business/components/Managements/BakeryManagement/pages/BakeryManagementPage";
import CateringManagementPage from "./business/components/Managements/CateringManagement/pages/CateringManagementPage";
import ProvisionManagementPage from "./business/components/Managements/ProvisionManagement/pages/ProvisionManagementPage";
import BusinessReviews from "./business/pages/Reviews/Reviews";
import BusinessEarnings from "./business/pages/Earnings/Earnings";
import BusinessAnalytics from "./business/pages/Analytics/Analytics";
import Business from "./business/pages/Business/Business";
import BusinessNotifications from "./business/pages/Notifications/Notifications";
import PrivacySettings from "./business/pages/Settings/PrivacySettings";
import SecuritySettings from "./business/pages/Settings/SecuritySettings";
import PreferencesSettings from "./business/pages/Settings/PreferencesSettings";
import DangerZone from "./business/pages/Settings/DangerZone";
// ==========================
// Admin Pages
// ==========================
import "./admin/admin-theme.css";
import AdminLogin from "./admin/pages/AdminLogin";
import Dashboard from "./admin/pages/Dashboard";
import AdminProtectedRoute from "./admin/routes/AdminProtectedRoute";

import Providers from "./admin/pages/Providers";
import AdminProviderDetails from "./admin/pages/ProviderDetails";
import AdminLayout from "./admin/layouts/AdminLayout";
import Customers from "./admin/pages/Customers";
import CustomerDetails from "./admin/pages/CustomerDetails";
import Delivery from "./admin/pages/Delivery";
import DeliveryDetails from "./admin/pages/DeliveryDetails";
import Category from "./admin/pages/Category";
import Foods from "./admin/pages/Foods";
import AdminFoodDetails from "./admin/pages/FoodDetails";
import AdminOrders from "./admin/pages/Orders";
import AdminOrderDetails from "./admin/pages/OrderDetails";
import Payments from "./admin/pages/Payments";
import AdminPaymentDetails from "./admin/pages/PaymentDetails";
import Reports from "./admin/pages/Reports";
import ReportDetails from "./admin/pages/ReportDetails";
// ==========================
// Notification Pages
// ==========================
import Notifications from "./admin/pages/Notifications";
import CreateNotification from "./admin/pages/CreateNotification";
import NotificationDetails from "./admin/pages/NotificationDetails";

import Reviews from "./admin/pages/Reviews";
import ReviewDetails from "./admin/pages/ReviewDetails";
import Coupons from "./admin/pages/Coupons";
import CouponDetails from "./admin/pages/CouponDetails";
import CreateCoupon from "./admin/pages/CreateCoupon";
import EditCoupon from "./admin/pages/EditCoupon";
import Earnings from "./admin/pages/Earnings";
import EarningDetails from "./admin/pages/EarningDetails";
import Settlements from "./admin/pages/Settlements";
import SettlementDetails from "./admin/pages/SettlementDetails";
import Marketing from "./admin/pages/Marketing";
import CreateCampaign from "./admin/pages/CreateCampaign";
import EditCampaign from "./admin/pages/EditCampaign";
import CampaignDetails from "./admin/pages/CampaignDetails";
import Support from "./admin/pages/Support";
import SupportDetails from "./admin/pages/SupportDetails";
import Roles from "./admin/pages/Roles";
import AdminUsers from "./admin/pages/AdminUsers";
import Settings from "./admin/pages/Settings";
import PendingProviders from "./admin/pages/providers/PendingProviders";
import ApplicationStatus from "./pages/provider/ApplicationStatus";
import CreatePassword from "./pages/provider/CreatePassword";
function AppContent() {

  const location = useLocation();

  const isBusiness =
    location.pathname.startsWith("/business");

  const hideNavbar = [

    "/",

    "/welcome",

    "/login",

    "/register",

    "/register/customer",

    "/register/provider",

    "/register/delivery",

    "/forgot-password"

  ].includes(location.pathname);

  return (

    <>

      <ModeManager />

      

      <Routes>

        {/* Splash */}

        <Route
          path="/"
          element={<Splash />}
        />

        <Route
          path="/welcome"
          element={<Welcome />}
        />

        {/* Authentication */}

        <Route
          path="/login"
          element={<Login />}
        />

        <Route
          path="/register"
          element={<Register />}
        />

        <Route
          path="/register/customer"
          element={<CustomerRegister />}
        />

      <Route
  path="/register/provider"
  element={<ProviderRegister />}
/>

   <Route
          path="/register/delivery"
          element={<DeliveryRegister />}
        />
        <Route
    path="/delivery/complete-profile"
    element={<DeliveryCompleteProfile />}
/>
<Route

    path="/delivery/vehicle-bank"

    element={<DeliveryVehicleBank />}

/>
<Route
    path="/delivery/application-submitted"
    element={<DeliveryApplicationSubmitted />}
/>
<Route
    path="/delivery/notifications"
    element={<DeliveryNotifications />}
/>
<Route
    path="/delivery/profile"
    element={<DeliveryProfile />}
/>
<Route
    path="/delivery/settings"
    element={<DeliverySettings />}
/>
<Route
    path="/delivery/edit-profile"
    element={<EditProfile />}
/>
<Route
    path="/delivery/privacy"
    element={<DeliveryPrivacy />}
/>
<Route
    path="/delivery/terms"
    element={<DeliveryTerms />}
/>
<Route
    path="/delivery/support"
    element={<DeliverySupport />}
/>
<Route
    path="/delivery/about"
    element={<DeliveryAbout />}
/>
<Route
    path="/delivery/change-password"
    element={<ChangePassword />}
/>
<Route
    path="/delivery/notification-settings"
    element={<DeliveryNotificationSettings />}
/>
<Route

    path="/delivery/verify-otp/:orderId"

    element={<OTPVerification />}

/>
<Route
    path="/delivery/orders"
    element={
        <ProtectedRoute>
            <DeliveryOrders />
        </ProtectedRoute>
    }
/>
<Route
    path="/delivery/earnings"
    element={
        <ProtectedRoute>
            <DeliveryEarnings />
        </ProtectedRoute>
    }
/>

<Route
    path="/delivery/location"
    element={<DeliveryLocation />}
/>
<Route
    path="/delivery/home"
    element={<DeliveryHome />}
/>

        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />

       <Route
    path="/admin/login"
    element={<AdminLogin />}
/>

<Route
    path="/admin"
    element={
        <AdminProtectedRoute>
            <AdminLayout />
        </AdminProtectedRoute>
    }
>

 

<Route
    path="reviews"
    element={<Reviews />}
/>

<Route
    path="reviews/:id"
    element={<ReviewDetails />}
/>
{/* ==========================
    Notifications
========================== */}

<Route
    path="notifications"
    element={<Notifications />}
/>

<Route
    path="notifications/create"
    element={<CreateNotification />}
/>

<Route
    path="notifications/:id"
    element={<NotificationDetails />}
/>
<Route
    path="delivery"
    element={<Delivery />}
/>

<Route
    path="delivery/:id"
    element={<DeliveryDetails />}
/>

<Route
    path="categories"
    element={<Category />}
/>
<Route
    path="foods"
    element={<Foods />}
/>


<Route
    path="foods/:id"
    element={<AdminFoodDetails />}
/>

<Route
    path="orders"
    element={<AdminOrders />}
/>

<Route
    path="orders/:id"
    element={<AdminOrderDetails />}
/>

<Route path="payments" element={<Payments />} />

<Route
    path="payments/:id"
    element={<AdminPaymentDetails />}
/>
<Route
    path="/admin/providers/pending"
    element={<PendingProviders />}
/>
<Route
  path="/admin/providers/:id"
  element={<AdminProviderDetails />}
/>
<Route
    path="reports"
    element={<Reports />}
/>

<Route
    path="reports/:id"
    element={<ReportDetails />}
/>
<Route
    path="coupons"
    element={<Coupons />}
/>

<Route
    path="coupons/:id"
    element={<CouponDetails />}
/>

<Route
    path="coupons/create"
    element={<CreateCoupon />}
/>

<Route
    path="coupons/edit/:id"
    element={<EditCoupon />}
/>
<Route
    path="earnings"
    element={<Earnings />}
/>

<Route
    path="earnings/:id"
    element={<EarningDetails />}
/>
<Route
    path="settlements"
    element={<Settlements />}
/>

<Route
    path="settlements/:id"
    element={<SettlementDetails />}
/>
<Route path="/admin/marketing" element={<Marketing />} />

<Route
    path="/admin/marketing/create"
    element={<CreateCampaign />}
/>

<Route
    path="/admin/marketing/edit/:id"
    element={<EditCampaign />}
/>

<Route
    path="/admin/marketing/:id"
    element={<CampaignDetails />}
/>
<Route
    path="/admin/support"
    element={<Support />}
/>

<Route
    path="/admin/support/:id"
    element={<SupportDetails />}
/>
<Route path="/admin/roles" element={<Roles />} />

<Route
    path="/admin/admin-users"
    element={<AdminUsers />}
/>
<Route
    path="/admin/settings"
    element={
        <AdminProtectedRoute>
            <Settings />
        </AdminProtectedRoute>
    }
/>
    {/* Default page after login */}
    <Route
        index
        element={<Dashboard />}
    />

    <Route
        path="dashboard"
        element={<Dashboard />}
    />

    <Route
        path="providers"
        element={<Providers />}
    />

    <Route
        path="providers/:id"
        element={<ProviderDetails />}
    />

    <Route
        path="customers"
        element={<Customers />}
    />
    

    <Route
        path="customers/:id"
        element={<CustomerDetails />}
    />

</Route>
        <Route
    path="/provider-registration-success"
    element={<RegistrationSuccess />}
/>
<Route
  path="/provider/application-status/:id"
  element={<ApplicationStatus />}
/>
<Route
    path="/create-password"
    element={<CreatePassword />}
/>
        {/* Customer */}

       <Route
  path="/home"
  element={
    <ProtectedRoute>
      <CustomerHome />
    </ProtectedRoute>
  }
/>

        <Route
          path="/food/:id"
          element={
            <ProtectedRoute>
              <FoodDetails />
            </ProtectedRoute>
          }
        />

      <Route
  path="/cart"
  element={
    <ProtectedRoute>
      <Checkout />
    </ProtectedRoute>
  }
/>
    <Route
    path="/customer/order-success"
    element={<OrderSuccess />}
/>
<Route
    path="/customer/live-tracking/:orderId"
    element={
        <ProtectedRoute>
            <LiveTracking />
        </ProtectedRoute>
    }
/>
<Route
    path="/customer/notifications"
    element={
        <ProtectedRoute>
            <CustomerNotifications />
        </ProtectedRoute>
    }
/>
<Route
    path="/provider/notifications"
    element={
        <BusinessProtectedRoute>
            <BusinessNotifications />
        </BusinessProtectedRoute>
    }
/>
<Route
    path="/delivery/notifications"
    element={<div>Delivery Notifications Coming Soon</div>}
/>
        <Route
  path="/provider/:providerId"
  element={
    <ProtectedRoute>
      <ProviderDetails />
    </ProtectedRoute>
  }
/>

        <Route
          path="/favorites"
          element={
            <ProtectedRoute>
              <Favorites />
            </ProtectedRoute>
          }
        />
    
<Route
  path="/recommended/:category"
  element={<RecommendedProviders />}
/>
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
   <Route
    path="/settings"
    element={
        <ProtectedRoute>
            <CustomerSettings />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/profile"
    element={
        <ProtectedRoute>
            <PersonalInformation />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/notifications"
    element={
        <ProtectedRoute>
            <NotificationSettings />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/privacy"
    element={
        <ProtectedRoute>
            <CustomerPrivacySettings />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/security"
    element={
        <ProtectedRoute>
            <CustomerSecuritySettings />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/appearance"
    element={
        <ProtectedRoute>
            <CustomerAppearanceSettings />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/language"
    element={
        <ProtectedRoute>
            <CustomerLanguageSettings />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/payments"
    element={
        <ProtectedRoute>
            <CustomerPaymentMethods />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/addresses"
    element={
        <ProtectedRoute>
            <CustomerSavedAddresses />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/help"
    element={
        <ProtectedRoute>
            <CustomerHelpSupport />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/about"
    element={
        <ProtectedRoute>
            <CustomerAbout />
        </ProtectedRoute>
    }
/>
<Route
    path="/settings/danger-zone"
    element={
        <ProtectedRoute>
            <CustomerDangerZone />
        </ProtectedRoute>
    }
/>
<Route
    path="/my-orders"
    element={
        <ProtectedRoute>
            <CustomerOrdersPage />
        </ProtectedRoute>
    }
/>
<Route
  path="/messages"
  element={
    <ProtectedRoute>
      <Messages />
    </ProtectedRoute>
  }
/>

       
        <Route
  path="/business/my-foods"
  element={
    <BusinessProtectedRoute>
      <FoodManagementPage />
    </BusinessProtectedRoute>
  }
/>

<Route
  path="/business/my-bakery"
  element={
    <BusinessProtectedRoute>
      <BakeryManagementPage />
    </BusinessProtectedRoute>
  }
/>
<Route
  path="/business/my-catering"
  element={
    <BusinessProtectedRoute>
      <CateringManagementPage />
    </BusinessProtectedRoute>
  }
/>
<Route
  path="/business/my-provision"
  element={<ProvisionManagementPage />}
/>

<Route
  path="/business/reviews"
  element={
    <BusinessProtectedRoute>
      <BusinessReviews />
    </BusinessProtectedRoute>
  }
/>
<Route
  path="/business/earnings"
  element={
    <BusinessProtectedRoute>
      <BusinessEarnings />
    </BusinessProtectedRoute>
  }
/>
<Route
  path="/business/analytics"
  element={
    <BusinessProtectedRoute>
      <BusinessAnalytics />
    </BusinessProtectedRoute>
  }
/>
<Route
  path="/business/profile"
  element={
    <BusinessProtectedRoute>
      <Business />
    </BusinessProtectedRoute>
  }
/>
<Route
    path="/business/messages"
    element={
        <BusinessProtectedRoute>
            <ProviderMessages />
        </BusinessProtectedRoute>
    }
/>
<Route
  path="/business/custom-orders/:orderId"
  element={
    <BusinessProtectedRoute>
      <CustomOrderReview />
    </BusinessProtectedRoute>
  }
/>
<Route
  path="/business/notifications"
  element={
    <BusinessProtectedRoute>
      <BusinessNotifications />
    </BusinessProtectedRoute>
  }
/>
 <Route
  path="/business/settings/privacy"
  element={
    <BusinessProtectedRoute>
      <PrivacySettings />
    </BusinessProtectedRoute>
  }
/>
<Route
  path="/business/settings/security"
  element={
    <BusinessProtectedRoute>
      <SecuritySettings />
    </BusinessProtectedRoute>
  }
/>
<Route
  path="/business/settings/preferences"
  element={
    <BusinessProtectedRoute>
      <PreferencesSettings />
    </BusinessProtectedRoute>
  }
/>

<Route
  path="/business/settings/danger-zone"
  element={
    <BusinessProtectedRoute>
      <DangerZone />
    </BusinessProtectedRoute>
  }
/>
        <Route
          path="/become-provider"
          element={
            <ProtectedRoute>
              <BecomeProvider />
            </ProtectedRoute>
          }
        />

        {/* Business */}

        <Route
          path="/business/home"
          element={
            <BusinessProtectedRoute>
              <BusinessHome />
            </BusinessProtectedRoute>
          }
        />

        <Route
          path="/business/profile"
          element={
            <BusinessProtectedRoute>
              <BusinessProfile />
            </BusinessProtectedRoute>
          }
        />

        <Route
          path="/business/orders"
          element={
            <BusinessProtectedRoute>
              <Orders />
            </BusinessProtectedRoute>
          }
        />

        <Route
  path="/onboarding/notifications"
  element={<NotificationPermission />}
/>

<Route
  path="/onboarding/location"
  element={<LocationPermission />}
/>

<Route
  path="/onboarding/service"
  element={<ChooseService />}
/>

      </Routes>

    </>

  );

}

function App() {

  return (

    <BrowserRouter>

      <CartProvider>

        <AppContent />

      </CartProvider>

    </BrowserRouter>

  );

}

export default App;